var _a;
import { createSlice } from '@reduxjs/toolkit';
var initialState = {
    status: null,
    profile: null,
    deductions: [],
};
var profileSlice = createSlice({
    name: 'profile',
    initialState: initialState,
    reducers: {
        setProfilePayload: function (state, action) {
            state.status = action.payload.status;
            state.profile = action.payload.profile;
            state.deductions = action.payload.deductions;
        },
        clearProfile: function (state) {
            state.status = null;
            state.profile = null;
            state.deductions = [];
        },
    },
});
export var setProfilePayload = (_a = profileSlice.actions, _a.setProfilePayload), clearProfile = _a.clearProfile;
export var selectProfileStatus = function (state) { return state.profile.status; };
export var selectProfile = function (state) { return state.profile.profile; };
export var selectProfileDeductions = function (state) { return state.profile.deductions; };
export default profileSlice.reducer;
